/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {  useState,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import api from '../../../service/axios/api';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';

const selectStyles = {
  control: provided => ({
    ...provided,
    height: 60,
    minHeight: 60,
  }),
  menu: provided => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 9999,
  }),
};

export default function Create({
  openCreate,
  setOpenCreate,
  loadingCreate,
  handleCreate,
  handleClean,
  client,
  setClient,
  amount,
  setAmount,
  dueDate,
  setDueDate,
  costCenter,
  setCostCenter,
  description,
  setDescription,
}) {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);

  const [clientList, setClientList] = useState([]);
  const [costCenterList, setCostCenterList] = useState([]);
  const [search, setSearch] = useState('');

  const getClients = async () => {
    try {
      const { data } = await api.legalEntities.getAllSelect(search);
      const list = [];
      data.retorno.forEach(item => {
        list.push({
          value: item.id,
          label: `${item.company_name} | ${item.cnpj}`,
        });
      });
      setClientList(list);
    } catch (error) {
      notifyError(error.message);
      console.log(error);
    }
  };

  const getCostCenters = async () => {
    try {
      const { data } = await api.costCenter.getAllSelect(search);
      const list = [
        {
          value: '',
          label: t('receivables.createDialog.fields.noCostCenter'),
        },
      ];
      data.retorno.forEach(item => {
        list.push({
          value: item.id,
          label: item.name,
        });
      });
      setCostCenterList(list);
    } catch (error) {
      notifyError(error.message);
      console.log(error);
    }
  };

  const handleClose = () => {
    handleClean();
    setSearch('');
  };

  useEffect(() => {
    getCostCenters();
  }, []);

  return (
    <Dialog
      onClose={() => setOpenCreate(false)}
      open={openCreate}
      fullWidth
      maxWidth="sm"
    >
      <Loading
        open={loadingCreate}
        msg={t('receivables.createDialog.loading')}
      />
      <DialogTitle id="simple-dialog-title">
        {t('receivables.createDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={3}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label={t('receivables.createDialog.fields.clientSearch')}
              variant="outlined"
              value={search}
              onChange={e => setSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Divider
                      orientation="vertical"
                      flexItem
                      style={{ height: 28, margin: 4, marginRight: 8 }}
                    />
                    <IconButton onClick={getClients} edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Select
              value={clientList.find(opt => opt.value === client)}
              placeholder={t('receivables.createDialog.fields.client')}
              onChange={e => setClient(e.value)}
              options={clientList}
              styles={selectStyles}
              maxMenuHeight={200}
              menuPortalTarget={document.body}
              captureMenuScroll
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider
              locale={locale}
              utils={DateFnsUtils}
              style={{ float: 'right ' }}
            >
              <KeyboardDatePicker
                autoOk
                label={t('receivables.createDialog.fields.dueDate')}
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dueDate}
                onChange={date => setDueDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label={t('receivables.createDialog.fields.amount')}
              variant="outlined"
              value={amount}
              onChange={e => setAmount(e.target.value)}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Select
              value={costCenterList.find(opt => opt.value === costCenter)}
              placeholder={t('receivables.createDialog.fields.costCenter')}
              onChange={e => setCostCenter(e.value)}
              options={costCenterList}
              styles={selectStyles}
              maxMenuHeight={200}
              menuPortalTarget={document.body}
              captureMenuScroll
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label={t('receivables.createDialog.fields.description')}
              variant="outlined"
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={handleClose}
          variant="text"
          color="primary"
        >
          {t('receivables.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40 }}
          onClick={handleCreate}
          disabled={loadingCreate}
          variant="contained"
          color="primary"
        >
          {t('receivables.createDialog.buttons.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
